export interface LocationProvider {
  readonly id:string;
  readonly capabilities:Record<string,unknown>;
  watch(success:PositionCallback,error?:PositionErrorCallback|null,options?:PositionOptions):number;
  current(success:PositionCallback,error?:PositionErrorCallback|null,options?:PositionOptions):void;
  clear(watchId:number):void;
}
export const browserLocationProvider:LocationProvider={
  id:'browser_geolocation',
  capabilities:{api:'W3C Geolocation API',fusedLocation:true,rawGnssMeasurements:false,externalReceiver:false,rtk:false},
  watch(success,error,options){if(!navigator.geolocation)throw new Error('Geolocation is not supported');return navigator.geolocation.watchPosition(success,error || undefined,options);},
  current(success,error,options){if(!navigator.geolocation)throw new Error('Geolocation is not supported');navigator.geolocation.getCurrentPosition(success,error || undefined,options);},
  clear(watchId){navigator.geolocation?.clearWatch(watchId);},
};
